import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=2d2e7739&scoped=true&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e7739",
  null
  
)

export default component.exports